import { render, staticRenderFns } from "./NumericUpDown.vue?vue&type=template&id=54befcad&scoped=true&"
import script from "./NumericUpDown.vue?vue&type=script&lang=ts&"
export * from "./NumericUpDown.vue?vue&type=script&lang=ts&"
import style0 from "./NumericUpDown.vue?vue&type=style&index=0&id=54befcad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54befcad",
  null
  
)

export default component.exports
import {QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QIcon})
